import React, { useEffect, useState } from "react";
import api from "../api/api";
import Header from "../components/header";
import "../styles/preview.css";

const alphabet = "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЮЯ".split("");

const Preview = () => {
  const [search, setSearch] = useState("");
  const [words, setWords] = useState([]);
  const [message, setMessage] = useState("");

  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("");


    /* ===============================
     LOAD REGIONS (CACHED) 
     TODO add another item for date and then compare with current date.
     if current date is greater with 4 hours than date_item the remove all items and reload all
     =============================== */
    
    /* useEffect(() => {
      const cached = localStorage.getItem("regions");
      if (cached) {
        setRegions(JSON.parse(cached));
      } else {
        loadRegions();
      }
    }, []); */
    useEffect(() => {
      localStorage.removeItem("regions");
      loadRegions();
    }, []);

    const loadRegions = async () => {
      try {
        const res = await api.get("/dictionary/getregions");
        setRegions(res.data || []);
        //localStorage.setItem("regions", JSON.stringify(res.data || []));
      } catch {
        console.error("Грешка при зареждане на региони.");
      } 
    };
  /* ===============================
     SEARCH
     =============================== */
  const searchWords = async () => {
    if (!search) {
      setWords([]);
      setMessage("Въведете дума за търсене.");
      return;
    }
    try {
      const res = await api.get("/dictionary/search", {
        params: { term: search,
        region: selectedRegion }
      });
      setWords(res.data || []);
      setMessage(res.data?.length === 0 ? "Няма резултати" : "");
    } catch {
      setMessage("❌ Грешка при търсене");
    } 
  };
  /* ===============================
     FILTER BY LETTER
     =============================== */
  const filterByLetter = async (letter) => {
    setSearch("");
    try {
      const res = await api.get(`/dictionary/searchbyletter/${letter}`, {
        params: { region: selectedRegion }
      });
      setWords(res.data || []);
      setMessage(res.data?.length === 0 ? "Няма резултати" : "");
    } catch {
      setMessage("❌ Грешка при търсене");
    } 
  };
  /* ===============================
     CLEAR
     =============================== */
  const clearAll = () => {
    setSearch("");
    setSelectedRegion("");
    setWords([]);
    setMessage("");
  };


  return (
    <div className="page-background">
      <div className="preview-container">
        <h1 className="header-text"><b>ПЕСНОСЛОВНИК</b></h1>
        <Header />

        <p>
            <select style={{maxWidth: "50%"}}
                value={selectedRegion}
                onChange={(e) => setSelectedRegion(e.target.value)}
              >
                <option value="">-- Всички региони --</option>
                {regions.map(r => (
                  <option key={r} value={r}>{r}</option>
                ))}
            </select>
        </p>
        {/* Alphabet */}
        <div className="alphabet-bar">
          {alphabet.map(letter => (
            <button
              key={letter}
              className="alphabet-btn"
              onClick={() => filterByLetter(letter)}
            >
              {letter}
            </button>
          ))}
        </div>

        {/* Search + Region */}        
        <div className="search-bar">          
          <input
            type="text"
            placeholder="Търсене на дума..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setMessage("");
            }}
          />         

          <div className="search-buttons">
            <button onClick={searchWords}>Търсене</button>
            <button onClick={clearAll}>
              Изчистване
            </button>
          </div>
        </div>

        {message && <p className="message">{message}</p>}

        {/* Words */}
        <ul className="word-list">
          {words.map(w => (
            <li key={w.id} className="word-card">
              <strong><u>{w.term}</u></strong>
              <p><i>Регион:</i> {w.region}</p>
              <p><i>Определение:</i> {w.definition}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Preview;
